import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgModule } from '@shared/components/svg/svg.module';
import { ImpairedIconComponent } from './impaired-icon/impaired-icon.component';

@NgModule({
  declarations: [ImpairedIconComponent],
  exports: [ImpairedIconComponent],
  imports: [CommonModule, SvgModule]
})
export class ImpairedIconModule {}
